import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useCommunityGroupsByMembership } from 'src/hook/useCommunityGroupsByMembership'
import { Loading } from 'src/components'
import { useCustomEvent } from 'src/hook/useCustomEvent'
import { ActionImportCommunity } from '../actionImportCommunity'
import { ActionCreateCommunity } from '../actionCreateCommunity'
import { MenuItem } from '../menuItem'
import { CommunityGroupHeader } from '../communityGroupHeader'
import { CommunityListMenuEventNames } from '../../communityListMenu.types'
import { Accordion } from '../accordion'
import { useCommunityPermissions } from '../../hooks'
import { PathParams } from './menu.types'

const Menu = () => {
  const { membership: membershipSlug } = useParams() as PathParams
  const { canImportCommunity, canCreateCommunity } = useCommunityPermissions()
  const {
    data: groupsResponse,
    isLoading,
    isRefetching,
    isError,
    invalidateQuery
  } = useCommunityGroupsByMembership({ membershipSlug })
  useCustomEvent(CommunityListMenuEventNames.UPDATE_COMMUNITY_LIST, invalidateQuery)

  const isValidCommunityGroups = useMemo(() => {
    return Boolean(Array.isArray(groupsResponse?.groups) && groupsResponse?.groups?.length > 0)
  }, [groupsResponse?.groups])

  if (isLoading || isRefetching) {
    return <Loading className="_d-flex _align-items-center _justify-content-center" />
  }

  if (isError || !isValidCommunityGroups) {
    return null
  }

  return (
    <>
      {groupsResponse?.groups?.map((group) => (
        <div key={group.id} className="_border-top">
          <Accordion label={<CommunityGroupHeader group={group} />} active>
            <Accordion.CollapseItem classNames="_pb-4">
              {canImportCommunity && <ActionImportCommunity group={group} />}

              {group?.communities?.data?.map((community) => (
                <MenuItem key={community.id} group={group} community={community} />
              ))}

              {canCreateCommunity && <ActionCreateCommunity groupId={group.id} />}
            </Accordion.CollapseItem>
          </Accordion>
        </div>
      ))}
    </>
  )
}

export default Menu
